import React, { useEffect, useState } from 'react';
import { Card } from 'Components/Common/Card/Card';
import { EsatusStack } from './EstatusStack';
import { Loader, Tag, Stack, Divider, IconButton, Whisper, Tooltip } from 'rsuite';
import api from 'Components/_helpers/api';
import CopyIcon from '@rsuite/icons/Copy';
import axios from 'axios';

export const Identificacion = (props) => {
  const { identificacion, firma, estatus, validationResult, otherValidationsResult } = props;

  const [catDefsIden, setCatDefsIden] = useState({ loading: true });

  const getCATDef_Iden = () => {
    const reqs = [
      api.post(`${api.getUri()}CAT/CAT002`, { code: identificacion.tipoDte }),
      api.post(`${api.getUri()}CAT/CAT003`, { code: identificacion.tipoModelo.toString() }),
      api.post(`${api.getUri()}CAT/CAT004`, { code: identificacion.tipoOperacion.toString() }),
    ];

    if (identificacion.tipoContingencia)
      reqs.push(api.post(`${api.getUri()}CAT/CAT005`, { code: identificacion.tipoContingencia.toString() }));

    axios.all(reqs).then(
      axios.spread((tipoDte, tipoModelo, tipoOperacion, tipoContingencia) => {
        const state = {
          loading: false,
          tipoDte: tipoDte.data.items.pop(),
          tipoModelo: tipoModelo.data.items.pop(),
          tipoOperacion: tipoOperacion.data.items.pop(),
        };

        if (tipoContingencia) state.tipoContingencia = tipoContingencia.data.items.pop();

        setCatDefsIden(state);
      })
    );
  };

  useEffect(() => {
    getCATDef_Iden();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [identificacion]);

  return (
    <Card header={'Información de identificación del DTE'}>
      <dl>
        <dt>Tipo de DTE</dt>
        <dd>{catDefsIden.loading ? <Loader /> : `${catDefsIden.tipoDte.code} - ${catDefsIden.tipoDte.value}`}</dd>
        <dt>Versión del DTE</dt>
        <dd>
          <Tag size="md" color="blue">
            {catDefsIden.loading ? <Loader /> : `${catDefsIden.tipoDte.value} Versión ${identificacion.version}`}
          </Tag>
        </dd>
        <dt>Fecha y hora de emisión</dt>
        <dd>
          <Tag size="md">
            {identificacion.fecEmi} {identificacion.horEmi}
          </Tag>
        </dd>
        <dt>Número de control</dt>
        <dd>
          <Tag size="md">{identificacion.numeroControl}</Tag>
        </dd>
        <dd></dd>
        <dt>Código de generación</dt>
        <dd>
          <Stack spacing={6}>
            <Tag size="md">{identificacion.codigoGeneracion}</Tag>
            <Whisper trigger="hover" placement={'auto'} speaker={<Tooltip>Copiar código de generación</Tooltip>}>
              <IconButton
                icon={<CopyIcon />}
                size="xs"
                onClick={() => {
                  navigator.clipboard.writeText(identificacion.codigoGeneracion);
                }}
              />
            </Whisper>
          </Stack>
        </dd>
        <dt>Tipo de modelo</dt>
        <dd>{catDefsIden.loading ? <Loader /> : `${catDefsIden.tipoModelo.code} - ${catDefsIden.tipoModelo.value}`}</dd>
        <dt>Tipo de operación</dt>
        <dd>{catDefsIden.loading ? <Loader /> : `${catDefsIden.tipoOperacion.code} - ${catDefsIden.tipoOperacion.value}`}</dd>
        {identificacion.tipoContingencia && (
          <>
            <dt>Tipo de contingencia</dt>
            <dd>{catDefsIden.loading ? <Loader /> : `${catDefsIden.tipoContingencia.code} - ${catDefsIden.tipoContingencia.value}`}</dd>
            <dt>Motivo de contingencia</dt>
            <dd>{identificacion.motivoContigencia}</dd>
          </>
        )}
        {firma.observaciones && (
          <>
            <dt>Detalle de observaciones de firma del DTE</dt>
            <dd>
              <ul>
                {firma.observaciones.map((o) => (
                  <li>{o}</li>
                ))}
              </ul>
            </dd>
          </>
        )}
      </dl>
      <div>
        <EsatusStack estatus={estatus} validationResult={validationResult} otherValidationsResult={otherValidationsResult} />
      </div>
      {validationResult.errors.length > 0 && (
        <>
          <Divider>¿Por qué no es válido este documento?</Divider>
          <div>
            <ul>
              {validationResult.errors.map((e) => (
                <li>{e}</li>
              ))}
            </ul>
          </div>
        </>
      )}
      {otherValidationsResult?.errors.length > 0 && (
        <>
          <Divider>Validaciones Adicionales</Divider>
          <div>
            <ul>
              {otherValidationsResult.errors.map((e) => (
                <li>{e}</li>
              ))}
            </ul>
          </div>
        </>
      )}
    </Card>
  );
};
